import React, {useEffect, useState} from 'react';
import Card from "../../Components/Card/Card";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import appConfigActions from "../../Actions/appConfigActions";
import useModal from "../../Hooks/useModal";
import Modals from "../../Constants/modals";
import {AppConfigTable} from "../../Components/Settings/AppConfig/AppConfigTable";
import AppConfigModal from "../../Components/Modals/AppConfig/AppConfigModal";

export default function AppConfigContainer({  }) {
    const dispatch = useDispatch();
    const actions = bindActionCreators(appConfigActions, dispatch);
    const appConfigs = useSelector((state) => state.SettingsReducer.appConfigs);
    const { openModal, isModalOpen } = useModal();
    const [ config, setConfig ] = useState(null);
    
    useEffect(() => {
        actions.getConfigurations();
    }, []);
    
    const handleEditClick = (e, config) => {
        e.stopPropagation();
        setConfig(config)
        actions.getEditModel(config, () => openModal(Modals.EditAppConfiguration));
    }
        
    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>Configurations</Card.Header.Title>
            </Card.Header>
            <Card.Content>
                <AppConfigTable appConfigs={appConfigs} onEditClick={handleEditClick}/>
            </Card.Content>
            {isModalOpen(Modals.EditAppConfiguration) && <AppConfigModal config={config}/>}
        </Card>
    )
}
